import * as React from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleStatus } from "../HurdleStatus";
import APIClient from "../../APIClient";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class DisclosureAprHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props: HurdleEditorProps) {
    super(props);
    const { override } = props.hurdle;
    this.state = {
      status: override && override.status ? override.status : null,
    };
  }

  componentDidMount() {
    const { app } = this.props;
    APIClient.get(`/uw/${app.id}/apr_comparison`, responseObject => {
      this.setState({ apr_comparison: responseObject.apr_comparison });
    });
  }

  renderAprComparison() {
    const { apr_comparison } = this.state;
    return (
      <div>
        <table className="table table-striped table-hover hurdles-editor__table">
          <thead>
            <tr>
              <th>Docmagic APR</th>
              <th>Eave APR</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{apr_comparison && apr_comparison.docmagic_estimate}</td>
              <td>{apr_comparison && apr_comparison.eave_estimate}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { app, hurdle, onHide } = this.props;
    const { status } = this.state;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <h4>APR Comparison:</h4>
        {this.renderAprComparison()}
        <h4>Override Status:</h4>
        <Select
          placeholder="override status"
          value={status}
          clearable={false}
          options={[
            {
              value: null,
              label: <span className="hurdles-editor__emdash">—</span>,
            },
            { value: "red", label: <HurdleStatus status="red" /> },
            { value: "yellow", label: <HurdleStatus status="yellow" /> },
            { value: "green", label: <HurdleStatus status="green" /> },
          ]}
          onChange={e => this.setState({ status: e.value })}
        />
        <br />
        <h4>Raw hurdle JSON:</h4>
        <pre>{JSON.stringify(hurdle, null, "\t")}</pre>
        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default DisclosureAprHurdleEditor;
